"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NotOnItemOverlay = void 0;
var _react = _interopRequireDefault(require("react"));
var _customisationModule = _interopRequireDefault(require("./customisation.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var NotOnItemOverlay = exports.NotOnItemOverlay = function NotOnItemOverlay(props) {
  if (!props.active || !props.canAdd) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "not-on-item-overlay",
    className: _customisationModule["default"].notOnItem,
    onClick: function onClick() {
      return props.canAdd && props.onAdd();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _customisationModule["default"].details
  }, "Add this customisation"));
};
var _default = exports["default"] = NotOnItemOverlay;